export default "__VITE_ASSET__DTke81cw__"